import { render, staticRenderFns } from "./ContestWinners.vue?vue&type=template&id=4d987145"
import script from "./ContestWinners.vue?vue&type=script&lang=ts"
export * from "./ContestWinners.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports